import { zExt } from "$root/third-party-integrations/zod";
import { SortDirectionEnum } from "@eu.mdotm.api/smart-workspaces";
import z from "zod";

export const chartPreferenceContent = z.object({
	hide: zExt.maybe(z.boolean()),
	sort: z.nativeEnum(SortDirectionEnum).optional().nullable(),
	/**
	 * The stacked column's second sort coordinate: which stacked segment `sort` orders the portfolios by.
	 * Absent or `null` means the stack total. The other kinds leave it unset — a `WORKSPACE` sort orders by
	 * the charted concept itself and needs no category (see `chartTypeSortingMode`).
	 */
	sortCategory: z.string().optional().nullable(),
	highlightProposal: z.boolean().optional(),
	/**
	 * The density chart's two overlays, each on unless the user turned it off — so absent reads as `true`,
	 * the opposite of {@link highlightProposal}. Read through the helpers in `../workspaceChart`, which is
	 * the one place that direction is written down.
	 *
	 * Persisted here rather than in `distributionProperties`, next to the binning the two charts share:
	 * these change nothing about what the backend bins, so a chart that only toggled one must not
	 * invalidate the `/distribution` query key.
	 */
	showMeanLines: z.boolean().optional(),
	showNormalFit: z.boolean().optional(),
});

const chartPreferencesV1 = zExt.versioned(1, chartPreferenceContent);
export const chartPreferencesLatest = chartPreferencesV1;
